import { useDataContext } from "../../context/DataContext";

// const parseTime = (time: string | undefined): number => {
//   if (!time) return NaN;
//   const parts = time.split(":").map(Number);
//   if (parts.length === 1) return NaN;
//   if (parts.length === 2) return parts[0] * 3600 + parts[1] * 60;
//   if (parts.length === 3) return parts[0] * 3600 + parts[1] * 60 + parts[2];
//   return NaN;
// };

// const checkTempos = (tempoHospital: any, tempoHospitalMediana: any): string => {
//   const time1 = parseTime(tempoHospital);
//   const time2 = parseTime(tempoHospitalMediana);
//   if (isNaN(time1) || isNaN(time2)) return "";
//   if (time1 < time2) return "";
//   if (time1 > time2 * 1.5) return "red";
//   return "yellow";
// };

// const calulaGaes = (media: any, gaes: any) => {
//   if (media && gaes) {
//     if (gaes * 1 > media * 1.5) return "red";
//     if (gaes * 1 > media * 1) return "yellow";
//   }
//   return "#000";
// };

// const validaMedia = (
//   media: any,
//   gaes: any,
//   tempoHospital: any,
//   tempoMediana: any
// ) => {
//   const valor1 = calulaGaes(media, gaes);
//   const valor2 = checkTempos(tempoHospital, tempoMediana);
//   if (valor1 === "red" || valor2 === "red") return "red";
//   if (valor1 === "yellow" || valor2 === "yellow") return "#ffce24";
//   return "black";
// };

const GetHospitalData = (hospitalId: any) => {
  const { data5, tempoMedio7dias, loading } = useDataContext();

  let totalPacientesAguardando = 0;
  let totalGAESAbertas = 0;
  let totalDesistentes = 0;
  let totalRiscoLaranja = 0;
  let totalRiscoAmarelo = 0;
  let totalRiscoVerde = 0;
  let totalRiscoAzul = 0;

  for (let especialidade in data5[hospitalId]) {
    const tempo_atendimento_semanal =
      tempoMedio7dias[hospitalId][especialidade];
    data5[hospitalId][especialidade].forEach(
      (item: {
        pacientes_aguardando_atendimento: number;
        gae_abertas: number;
        pacientes_desistentes: number;
        risco_laranja: number;
        risco_amarelo: number;
        risco_verde: number;
        risco_azul: number;
      }) => {
        totalPacientesAguardando += item.pacientes_aguardando_atendimento;
        totalGAESAbertas += item.gae_abertas;
        totalDesistentes += item.pacientes_desistentes;
        totalRiscoLaranja += item.risco_laranja;
        totalRiscoAmarelo += item.risco_amarelo;
        totalRiscoVerde += item.risco_verde;
        totalRiscoAzul += item.risco_azul;
      }
    );
  }

  if (loading) return <p>Loading...</p>;

  // const item = data.find((item: any) => item.hospital === hospitalId);
  // if (!item) return <p>Hospital not found</p>;

  // const dataItem = data2.find((d: any) => d.hospital === item.hospital);
  // const valor2Item = data3.find((d: any) => d.hospital === item.hospital);
  // const valor3Item = data4.find(
  //   (d: any) =>
  //     d.i_sigla_estab_trak?.toLowerCase() === item?.hospital?.toLowerCase()
  // );

  // const validaColor =
  //   valor2Item && dataItem && valor3Item
  //     ? validaMedia(
  //         valor2Item.media_movel,
  //         dataItem.gae_abertas,
  //         dataItem.tempo_atendimento.substring(0, 8),
  //         valor3Item.tempo_espera_mediano.substring(0, 8)
  //       )
  //     : "black";

  return {
    // Hospital: item.hospital,
    Hospital: hospitalId,
    // CordeValidação: validaColor,
    // PacientesAguardando: dataItem?.pacientes_aguardando_atendimento || "0",
    PacientesAguardando: totalPacientesAguardando,
    // TempoDeAtendimento: dataItem?.tempo_atendimento || "0",
    // GAESAbertas: dataItem?.gae_abertas || "0",
    GAESAbertas: totalGAESAbertas,
    // MediaMovel: valor2Item?.media_movel || "0",
    // TempoEsperaMediano: valor3Item?.tempo_espera_mediano || "0",
    Desistentes: totalDesistentes,
    total_risco_laranja: totalRiscoLaranja,
    total_risco_amarelo: totalRiscoAmarelo,
    total_risco_verde: totalRiscoVerde,
    total_risco_azul: totalRiscoAzul,
  };
};

export default GetHospitalData;
